import * as PartnersActionTypes from '../../constants/actiontypes/backoffice/partners';
import * as PartnersLoadings from '../../constants/loadings/backoffice/partners';
import Partner from '../../constants/models/backoffice/partner';


import User from '../../constants/models/user';
import * as R from 'ramda';
import { toast } from 'react-toastify';
import toastConf from '../../utils/toasterConfiguration';

import * as ToasterText from '../../constants/toasterText/backofficePartners';



const PartnersReducer = (state = {
    isLoading: [],
    partners: undefined,
    defaultPartners: undefined,
    partner: undefined,
    resetPasswordPhoneNumber: false,
    totalPages: 0,
    totalRecords: 0,
    currentPage: 0,
    usersPagination: {
        totalPages: 0,
        totalRecords: 0,
        currentPage: 0,
    },
    etablissementsPagination: {
        totalPages: 0,
        totalRecords: 0,
        currentPage: 0,
    }

}, action) => {
    switch (action.type) {
        case PartnersActionTypes.FETCH_PARTNER_REQUEST:
            if (!state.isLoading.includes(PartnersLoadings.FETCHING_PARTNER)) {
                state.isLoading = state.isLoading.concat(PartnersLoadings.FETCHING_PARTNER);
            }
            return { ...state };

        case PartnersActionTypes.FETCH_PARTNER_SUCCESS:
            state.isLoading = state.isLoading.filter(l => l !== PartnersLoadings.FETCHING_PARTNER);
            state.partner = new Partner(action.data);
            return { ...state };


        case PartnersActionTypes.FETCH_PARTNER_FAILURE:
            state.isLoading = state.isLoading.filter(l => l !== PartnersLoadings.FETCHING_PARTNER);
            return { ...state };

        //#region Partners
        case PartnersActionTypes.FETCH_PARTNERS_REQUEST:
            if (!state.isLoading.includes(PartnersLoadings.FETCHING_PARTNERS)) {
                state.isLoading = state.isLoading.concat(PartnersLoadings.FETCHING_PARTNERS);
            }
            return { ...state };

        case PartnersActionTypes.FETCH_PARTNERS_SUCCESS:
            state.isLoading = state.isLoading.filter(l => l !== PartnersLoadings.FETCHING_PARTNERS);
            state.partners = action.data.items.map(l => new Partner(l));

            state.totalPages = action.data.totalPages;
            state.totalRecords = action.data.totalRecords;
            state.currentPage = action.data.pageNumber + 1;
            return { ...state };


        case PartnersActionTypes.FETCH_PARTNERS_FAILURE:
            state.isLoading = state.isLoading.filter(l => l !== PartnersLoadings.FETCHING_PARTNERS);
            return { ...state };

        case PartnersActionTypes.FETCH_PARTNERS_DEFAULT_REQUEST:
            if (!state.isLoading.includes(PartnersLoadings.FETCHING_PARTNERS_DEFAULT)) {
                state.isLoading = state.isLoading.concat(PartnersLoadings.FETCHING_PARTNERS_DEFAULT);
            }
            return { ...state };

        case PartnersActionTypes.FETCH_PARTNERS_DEFAULT_SUCCESS:
            state.isLoading = state.isLoading.filter(l => l !== PartnersLoadings.FETCHING_PARTNERS_DEFAULT);
            state.defaultPartners = action.data.items.map(l => new Partner(l));
            return { ...state };

        case PartnersActionTypes.FETCH_PARTNERS_DEFAULT_FAILURE:
            state.isLoading = state.isLoading.filter(l => l !== PartnersLoadings.FETCHING_PARTNERS_DEFAULT);
            return { ...state };

        case PartnersActionTypes.CREATE_PARTNER_REQUEST:
            if (!state.isLoading.includes(PartnersLoadings.CREATING_PARTNER)) {
                state.isLoading = state.isLoading.concat(PartnersLoadings.CREATING_PARTNER);
            }
            return { ...state };

        case PartnersActionTypes.CREATE_PARTNER_SUCCESS:
            state.isLoading = state.isLoading.filter(l => l !== PartnersLoadings.CREATING_PARTNER);
            state.partners = [...state.partners, new Partner(action.data)];
            return { ...state };


        case PartnersActionTypes.CREATE_PARTNER_FAILURE:
            state.isLoading = state.isLoading.filter(l => l !== PartnersLoadings.CREATING_PARTNER);
            return { ...state };

        case PartnersActionTypes.UPDATE_PARTNER_REQUEST:
            if (!state.isLoading.includes(PartnersLoadings.UPDATING_PARTNER)) {
                state.isLoading = state.isLoading.concat(PartnersLoadings.UPDATING_PARTNER);
            }
            return { ...state };

        case PartnersActionTypes.UPDATE_PARTNER_SUCCESS:
            // state.partners = state.partners.map((partner) => {
            //     if (partner.id !== action.partnerId) {
            //         return partner;
            //     } else {
            //         const newPartner = new Partner(action.data);
            //         newPartner.users = partner.users;
            //         newPartner.etablissements = partner.etablissements;
            //         return newPartner;
            //     }
            // });

            const newPartner = new Partner(action.data);
            newPartner.etablissements = state.partner.etablissements;
            newPartner.users = state.partner.users;
            state.partner = newPartner;
            state.isLoading = state.isLoading.filter(l => l !== PartnersLoadings.UPDATING_PARTNER);
            return { ...state };

        case PartnersActionTypes.UPDATE_PARTNER_FAILURE:
            state.isLoading = state.isLoading.filter(l => l !== PartnersLoadings.UPDATING_PARTNER);
            return { ...state };

        case PartnersActionTypes.DELETE_PARTNER_REQUEST:
            if (!state.isLoading.includes(PartnersLoadings.DELETING_USER)) {
                state.isLoading = state.isLoading.concat(PartnersLoadings.DELETING_PARTNER);
            }
            return { ...state };

        case PartnersActionTypes.DELETE_PARTNER_SUCCESS:
            state.isLoading = state.isLoading.filter(l => l !== PartnersLoadings.DELETING_PARTNER);
            state.partners = state.partners.filter(u => u.id !== action.partnerId);
            return { ...state };

        case PartnersActionTypes.DELETE_PARTNER_FAILURE:
            state.isLoading = state.isLoading.filter(l => l !== PartnersLoadings.DELETING_PARTNER);
            return { ...state };

        case PartnersActionTypes.UPLOAD_LOGO_REQUEST:
            if (!state.isLoading.includes(PartnersLoadings.UPLOADING_LOGO)) {
                state.isLoading = state.isLoading.concat(PartnersLoadings.UPLOADING_LOGO);
            }
            return { ...state };

        case PartnersActionTypes.UPLOAD_LOGO_SUCCESS:
            state.isLoading = state.isLoading.filter(l => l !== PartnersLoadings.UPLOADING_LOGO);
            // state.partners = state.partners.map((partner) => {
            //     if (partner.id !== action.partnerId) {
            //         return partner;
            //     } else {
            //         return { ...partner, hasLogo: true };
            //     }
            // });
            state.partner = { ...state.partner, hasLogo: true };
            return { ...state };

        case PartnersActionTypes.UPLOAD_LOGO_FAILURE:
            state.isLoading = state.isLoading.filter(l => l !== PartnersLoadings.UPLOADING_LOGO);
            return { ...state };

        //#endregion

        //#region Etablissements
        case PartnersActionTypes.FETCH_ETABLISSEMENTS_REQUEST:
            if (!state.isLoading.includes(PartnersLoadings.FETCHING_ETABLISSEMENTS)) {
                state.isLoading = state.isLoading.concat(PartnersLoadings.FETCHING_ETABLISSEMENTS);
            }
            return { ...state };

        case PartnersActionTypes.FETCH_ETABLISSEMENTS_SUCCESS:
            state.isLoading = state.isLoading.filter(l => l !== PartnersLoadings.FETCHING_ETABLISSEMENTS);
            // state.partners = state.partners.map((partner) => {
            //     if (partner.id !== action.partnerId) {
            //         return partner;
            //     } else {
            //         return {
            //             ...partner,
            //             etablissements: action.data.items
            //         };
            //     }
            // });
            state.partner.etablissements = action.data.items;
            state.etablissementsPagination = {
                totalPages: action.data.totalPages,
                totalRecords: action.data.totalRecords,
                currentPage: action.data.pageNumber + 1,
            };
            // state.etablissementsPagination.totalPages = action.data.totalPages
            // state.etablissementsPagination.totalRecords = action.data.totalRecords
            // state.etablissementsPagination.currentPage = action.data.pageNumber + 1

            return { ...state };


        case PartnersActionTypes.FETCH_ETABLISSEMENTS_FAILURE:
            state.isLoading = state.isLoading.filter(l => l !== PartnersLoadings.FETCHING_ETABLISSEMENTS);
            return { ...state };



        case PartnersActionTypes.CREATE_ETABLISSEMENT_REQUEST:
            if (!state.isLoading.includes(PartnersLoadings.CREATING_ETABLISSEMENT)) {
                state.isLoading = state.isLoading.concat(PartnersLoadings.CREATING_ETABLISSEMENT);
            }
            return { ...state };

        case PartnersActionTypes.CREATE_ETABLISSEMENT_SUCCESS:
            state.isLoading = state.isLoading.filter(l => l !== PartnersLoadings.CREATING_ETABLISSEMENT);
            // state.partners = state.partners.map((partner) => {
            //     if (partner.id !== action.partnerId) {
            //         return partner;
            //     } else {
            //         return {
            //             ...partner,
            //             etablissements: [...partner.etablissements, action.data]
            //         };
            //     }
            // });
            state.partner.etablissements = [...state.partner.etablissements, action.data];
            return { ...state };

        case PartnersActionTypes.CREATE_ETABLISSEMENT_FAILURE:
            state.isLoading = state.isLoading.filter(l => l !== PartnersLoadings.CREATING_ETABLISSEMENT);
            if(action.error.status === 409){
                toast.error(ToasterText.etablissementCreationConflict, toastConf);
            }
            return { ...state };

        case PartnersActionTypes.UPDATE_ETABLISSEMENT_REQUEST:
            if (!state.isLoading.includes(PartnersLoadings.UPDATING_ETABLISSEMENT)) {
                state.isLoading = state.isLoading.concat(PartnersLoadings.UPDATING_ETABLISSEMENT);
            }
            return { ...state };

        case PartnersActionTypes.UPDATE_ETABLISSEMENT_SUCCESS:
            state.isLoading = state.isLoading.filter(l => l !== PartnersLoadings.UPDATING_ETABLISSEMENT);
            // state.partners = state.partners.map((partner) => {
            //     if (partner.id !== action.partnerId) {
            //         return partner;
            //     } else {
            //         return {
            //             ...partner,
            //             etablissements: partner.etablissements.map((etablissement) => {
            //                 if (etablissement.id === action.data.id) {
            //                     return { ...action.data };
            //                 } else {
            //                     return etablissement;
            //                 }
            //             })
            //         };
            //     }
            // });
            state.partner.etablissements = state.partner.etablissements.map((etablissement) => {
                if (etablissement.id === action.data.id) {
                    return { ...action.data };
                } else {
                    return etablissement;
                }
            });

            return { ...state };

        case PartnersActionTypes.UPDATE_ETABLISSEMENT_FAILURE:
            state.isLoading = state.isLoading.filter(l => l !== PartnersLoadings.UPDATING_ETABLISSEMENT);
            return { ...state };

        case PartnersActionTypes.DELETE_ETABLISSEMENT_REQUEST:
            if (!state.isLoading.includes(PartnersLoadings.DELETING_ETABLISSEMENT)) {
                state.isLoading = state.isLoading.concat(PartnersLoadings.DELETING_ETABLISSEMENT);
            }
            return { ...state };

        case PartnersActionTypes.DELETE_ETABLISSEMENT_SUCCESS:
            state.isLoading = state.isLoading.filter(l => l !== PartnersLoadings.DELETING_ETABLISSEMENT);
            // state.partners = state.partners.map((partner) => {
            //     if (partner.id !== action.partnerId) {
            //         return partner;
            //     } else {
            //         return {
            //             ...partner,
            //             etablissements: partner.etablissements.filter(u => u.id !== action.etablissementId)
            //         };
            //     }
            // });
            state.partner.etablissements = state.partner.etablissements.filter(u => u.id !== action.etablissementId);
            return { ...state };

        case PartnersActionTypes.DELETE_ETABLISSEMENT_FAILURE:
            state.isLoading = state.isLoading.filter(l => l !== PartnersLoadings.DELETING_ETABLISSEMENT);
            return { ...state };

        case PartnersActionTypes.GENERATE_ETABLISSEMENT_API_KEY_REQUEST:
            if (!state.isLoading.includes(PartnersLoadings.GENERATING_ETABLISSEMENT_API_KEY)) {
                state.isLoading = state.isLoading.concat(PartnersLoadings.GENERATING_ETABLISSEMENT_API_KEY);
            }
            return { ...state };

        case PartnersActionTypes.GENERATE_ETABLISSEMENT_API_KEY_SUCCESS:
            state.isLoading = state.isLoading.filter(l => l !== PartnersLoadings.GENERATING_ETABLISSEMENT_API_KEY);
            toast.success(ToasterText.apiKeyGeneratedSuccess, toastConf);
            return { ...state };

        case PartnersActionTypes.GENERATE_ETABLISSEMENT_API_KEY_FAILURE:
            state.isLoading = state.isLoading.filter(l => l !== PartnersLoadings.GENERATING_ETABLISSEMENT_API_KEY);
            toast.error(ToasterText.apiKeyGeneratedFailure, toastConf);
            return { ...state };
        //#endregion

        //#region Users
        case PartnersActionTypes.FETCH_USERS_REQUEST:
            if (!state.isLoading.includes(PartnersLoadings.FETCHING_USERS)) {
                state.isLoading = state.isLoading.concat(PartnersLoadings.FETCHING_USERS);
            }
            return { ...state };

        case PartnersActionTypes.FETCH_USERS_SUCCESS:
            state.isLoading = state.isLoading.filter(l => l !== PartnersLoadings.FETCHING_USERS);
            // state.partners = state.partners.map((partner) => {
            //     if (partner.id !== action.partnerId) {
            //         return partner;
            //     } else {
            //         return {
            //             ...partner,
            //             users: action.data.items.length > 0 ? action.data.items.map(u => new User(u)) : [],
            //         };
            //     }
            // });
            state.partner.users = action.data.items.length > 0 ? action.data.items.map(u => new User(u)) : [];
            state.usersPagination = {
                totalPages: action.data.totalPages,
                totalRecords: action.data.totalRecords,
                currentPage: action.data.pageNumber + 1,
            };
            return { ...state };


        case PartnersActionTypes.FETCH_USERS_FAILURE:
            state.isLoading = state.isLoading.filter(l => l !== PartnersLoadings.FETCHING_USERS);
            return { ...state };



        case PartnersActionTypes.CREATE_USER_REQUEST:
            if (!state.isLoading.includes(PartnersLoadings.CREATING_USER)) {
                state.isLoading = state.isLoading.concat(PartnersLoadings.CREATING_USER);
            }
            return { ...state };

        case PartnersActionTypes.CREATE_USER_SUCCESS:
            state.isLoading = state.isLoading.filter(l => l !== PartnersLoadings.CREATING_USER);
            // state.partners = state.partners.map((partner) => {
            //     if (partner.id !== action.partnerId) {
            //         return partner;
            //     } else {
            //         return {
            //             ...partner,
            //             users: [...partner.users, new User(action.data)]
            //         };
            //     }
            // });
            state.partner.users = [...state.partner.users, new User(action.data)];
            return { ...state };

        case PartnersActionTypes.CREATE_USER_FAILURE:
            state.isLoading = state.isLoading.filter(l => l !== PartnersLoadings.CREATING_USER);
            return { ...state };

        case PartnersActionTypes.UPDATE_USERPARTNER_REQUEST:
            if (!state.isLoading.includes(PartnersLoadings.UPDATING_USER)) {
                state.isLoading = state.isLoading.concat(PartnersLoadings.UPDATING_USER);
            }
            return { ...state };

        case PartnersActionTypes.UPDATE_USERPARTNER_SUCCESS:
            state.isLoading = state.isLoading.filter(l => l !== PartnersLoadings.UPDATING_USER);
            // state.partners = state.partners.map((partner) => {
            //     if (partner.id !== action.partnerId) {
            //         return partner;
            //     } else {
            //         return {
            //             ...partner,
            //             users: partner.users.map((user) => {
            //                 if (user.id === action.data.id) {
            //                     return new User(action.data);
            //                 } else {
            //                     return user;
            //                 }
            //             })
            //         };
            //     }
            // });
            state.partner.users = state.partner.users.map((user) => {
                if (user.id === action.data.id) {
                    return new User(action.data);
                } else {
                    return user;
                }
            });
            return { ...state };

        case PartnersActionTypes.UPDATE_USERPARTNER_FAILURE:
            state.isLoading = state.isLoading.filter(l => l !== PartnersLoadings.UPDATING_USER);
            return { ...state };

        case PartnersActionTypes.DELETE_USER_REQUEST:
            if (!state.isLoading.includes(PartnersLoadings.DELETING_USER)) {
                state.isLoading = state.isLoading.concat(PartnersLoadings.DELETING_USER);
            }
            return { ...state };

        case PartnersActionTypes.DELETE_USER_SUCCESS:
            state.isLoading = state.isLoading.filter(l => l !== PartnersLoadings.DELETING_USER);
            // state.partners = state.partners.map((partner) => {
            //     if (partner.id !== action.partnerId) {
            //         return partner;
            //     } else {
            //         return {
            //             ...partner,
            //             users: partner.users.filter(u => u.id !== action.userId)
            //         };
            //     }
            // });
            state.partner.users = state.partner.users.filter(u => u.id !== action.userId);
            return { ...state };

        case PartnersActionTypes.DELETE_USER_FAILURE:
            state.isLoading = state.isLoading.filter(l => l !== PartnersLoadings.DELETING_USER);
            return { ...state };

        case PartnersActionTypes.SEND_USER_ACTIVATION_REQUEST:
            if (!state.isLoading.includes(PartnersLoadings.SENDING_USER_ACTIVATION)) {
                state.isLoading = state.isLoading.concat(PartnersLoadings.SENDING_USER_ACTIVATION);
            }
            return { ...state };

        case PartnersActionTypes.SEND_USER_ACTIVATION_SUCCESS:
            toast.success(ToasterText.activationEmailSendingSuccess, toastConf);
            state.isLoading = state.isLoading.filter(l => l !== PartnersLoadings.SENDING_USER_ACTIVATION);
            return { ...state };

        case PartnersActionTypes.SEND_USER_ACTIVATION_FAILURE:
            toast.error(ToasterText.activationEmailSendingError, toastConf);
            state.isLoading = state.isLoading.filter(l => l !== PartnersLoadings.SENDING_USER_ACTIVATION);
            return { ...state };

        //#endregion



        default:
            return state;
    }
};
export default PartnersReducer;
//toast.success(Text.dataUpdatedSuccess, toastConf);